"use client";

import React, { useEffect, useState } from "react";

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
  },
};

export default function BarChart({ data }) {
  const [Chart, setChart] = useState(null);

  useEffect(() => {
    const loadChart = async () => {
      const chartModule = await import("chart.js");
      const { Bar } = await import("react-chartjs-2");
      
      const { Chart: ChartJS, CategoryScale, BarElement, LinearScale, Title, Tooltip, Legend } = chartModule;
      ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
      setChart(() => Bar);
    };

    loadChart();
  }, []);

  // if undefined or chart not loaded, return null
  if (!data || !Chart) return null;
  
  return <Chart data={data} options={options} />;
}